import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_TextInput from "../components/BSL_TextInput";
import * as BSL_Common from "../components/BSL_CommonControls";
import { IconButton } from "@material-ui/core";
import { Palette } from "../AppConfig";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        maxWidth: "90%",
        minWidth: "600px",
    },
    container: {
        height: "90%",
        maxHeight: "800px",
    },
    row: {
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        padding: "2px 0px 2px 24px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
    },
    categoryHeadingCell: {
        textAlign: "center",
        backgroundColor: Palette.FieldersOrange + " !important",
        padding: "2px !important",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        borderLeft: "1px solid white !important",
        borderRight: "1px solid white !important",
        position: "sticky",
        top: "0px !important",
    },
    categoryHeadingCellBlank: {
        textAlign: "center",
        backgroundColor: "#ffffff !important",
        padding: "2px !important",
        position: "sticky",
        top: "0px !important",
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        // padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: Palette.FieldersBlue,
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },
    headingRow: {
        backgroundColor: Palette.FieldersBlue,
    },
    editor: {
        border: "1px solid grey",
        width: "40px",
    },
}));

const wz_columns = () => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
    },
    {
        id: "MaxInternalSpan",
        label: "Internal",
        grouping: "Default Spans (1 Side)",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxEndSpan",
        label: "End",
        grouping: "Default Spans (1 Side)",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxOverhang",
        label: "Overhang",
        grouping: "Default Spans (1 Side)",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxInternalSpan_2Sides",
        label: "Internal",
        grouping: "2 Sides Blocked",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxEndSpan_2Sides",
        label: "End",
        grouping: "2 Sides Blocked",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxOverhang_2Sides",
        label: "Overhang",
        grouping: "2 Sides Blocked",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxInternalSpan_3Sides",
        label: "Internal",
        grouping: "3 Sides Blocked",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxEndSpan_3Sides",
        label: "End",
        grouping: "3 Sides Blocked",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxOverhang_3Sides",
        label: "Overhang",
        grouping: "3 Sides Blocked",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxInternalSpan_0Sides",
        label: "Internal",
        grouping: "Freestanding",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxEndSpan_0Sides",
        label: "End",
        grouping: "Freestanding",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
    {
        id: "MaxOverhang_0Sides",
        label: "Overhang",
        grouping: "Freestanding",
        style: {
            width: "100px",
        },
        validate: "numbersOnly",
    },
];

export default function ManageMaterialsSpans(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { row, saveValue, onClose } = props;
    const [spans, setSpans] = React.useState({ ...row.Spans });
    const [displayData, setDisplayData] = React.useState(JSON.stringify(row.Spans, null, 4));
    const [displayDataValidJSON, setDisplayDataValidJSON] = React.useState(true);

    const [edit, setEdit] = React.useState(null);

    const checkValidJSON = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            setDisplayDataValidJSON(false);
            return false;
        }
        setDisplayDataValidJSON(true);
        return true;
    };

    const setSpanValue = (parent, parameter, value) => {
        let data = { ...spans };
        if (parent) {
            if (data?.[parent] === undefined) data[parent] = {};
            data[parent][parameter] = Number(value);
            if (value === "") delete data[parent][parameter];
        } else {
            data[parameter] = Number(value);
            if (value === "") delete data[parameter][parameter];
        }
        setSpans(data);
        setDisplayData(JSON.stringify(data, null, 4));
    };

    // React.useEffect(() => {
    //     setDisplayData(getData());
    // }, [MaxInternalSpan, MaxEndSpan, MaxOverhang]);

    const getData = () => {
        let data = "";
        return data;
    };

    const getGroupHeaders = (columns) => {
        let grouping_headers = [];

        let last_grouping = undefined;
        let num_in_this_group = -1;
        let header_i = 0;
        for (let column of columns()) {
            if (column?.hideInTable) continue;
            let this_grouping = column?.grouping;
            if (
                this_grouping !== last_grouping ||
                (this_grouping === undefined && last_grouping) ||
                num_in_this_group > 8
            ) {
                //change in grouping. print cell

                let cell_style = {};
                if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

                grouping_headers.push(
                    <TableCell
                        key={column.id}
                        className={
                            (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
                            " " +
                            classes.headingCell
                        }
                        style={cell_style}
                        colSpan={num_in_this_group + 1}
                    >
                        {last_grouping ? last_grouping : ""}
                    </TableCell>
                );
                header_i++;
                last_grouping = this_grouping;
                num_in_this_group = 0;
            } else {
                num_in_this_group++;
            }
        }

        if (num_in_this_group > 0) {
            let cell_style = {};
            if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

            grouping_headers.push(
                <TableCell
                    key={"beam_col_end"}
                    className={
                        (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
                        " " +
                        classes.headingCell
                    }
                    colSpan={num_in_this_group + 1}
                >
                    {last_grouping ? last_grouping : ""}
                </TableCell>
            );
        }
        return grouping_headers;
    };

    let keys = ["N1", "N2", "N3", "N4", "N5", "N6", "C1", "C2", "C3", "C4"];

    return (
        <BSL_Dialog
            title={"Edit Spans for " + row?.["Name"]}
            open={true}
            // onClose={onClose}
            button1Text="Update"
            button1Click={() => {
                if (!displayDataValidJSON) {
                    alert("JSON is not valid. You cannot save this data. Fix it up and try again.");
                } else {
                    saveValue(props.section, props.ref_key, props.row, "Spans", spans);
                }
            }}
            button2Text="Cancel"
            button2Click={onClose}
            style={{ maxWidth: "initial" }}
            fullWidth={true}
            maxWidth={"xl"}
        >
            <BSL_Common.SectionRow>
                <BSL_Common.SectionColumn>
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Max Internal Span"
                            value={spans?.MaxInternalSpan}
                            preValidate="numbersOnly"
                            tight
                            style={{ flex: "none", width: "120px" }}
                            onEnter={(e) => setSpanValue(null, "MaxInternalSpan", e.target.value)}
                            onChange={(val) => setSpanValue(null, "MaxInternalSpan", val)}
                            onBlur={(val) => setSpanValue(null, "MaxInternalSpan", val)}
                        />
                        <BSL_TextInput
                            label="Max End Span"
                            value={spans?.MaxEndSpan}
                            preValidate="numbersOnly"
                            tight
                            style={{ flex: "none", width: "120px" }}
                            onEnter={(e) => setSpanValue(null, "MaxEndSpan", e.target.value)}
                            onChange={(val) => setSpanValue(null, "MaxEndSpan", val)}
                            onBlur={(val) => setSpanValue(null, "MaxEndSpan", val)}
                        />
                        <BSL_TextInput
                            label="Max Overhang"
                            value={spans?.MaxOverhang}
                            preValidate="numbersOnly"
                            tight
                            style={{ flex: "none", width: "120px" }}
                            onEnter={(e) => setSpanValue(null, "MaxOverhang", e.target.value)}
                            onChange={(val) => setSpanValue(null, "MaxOverhang", val)}
                            onBlur={(val) => setSpanValue(null, "MaxOverhang", val)}
                        />
                    </BSL_Common.SectionRow>
                    <TableContainer className={classes.container}>
                        <Table stickyHeader size="small" aria-label="sticky table">
                            <TableHead>
                                <TableRow>{getGroupHeaders(wz_columns)}</TableRow>
                                <TableRow className={classes.headingRow}>
                                    {wz_columns().map((column) =>
                                        column?.hideInTable ? null : (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                                style={column?.style}
                                                className={classes.headingCell}
                                            >
                                                {column.label}
                                            </TableCell>
                                        )
                                    )}
                                    {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                    <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {keys.map((key, index) => {
                                    return (
                                        <TableRow
                                            key={key}
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={classes.row}
                                            style={{
                                                background: index % 2 === 0 ? "#e7ebee" : "#ffffff",
                                            }}
                                        >
                                            {wz_columns().map((column) => {
                                                let inherit = false;
                                                let inherit_value = 0;
                                                if (column.id.includes("MaxInternalSpan")) {
                                                    inherit_value = spans?.MaxInternalSpan;
                                                    if (spans?.[key]?.MaxInternalSpan !== undefined)
                                                        inherit_value = spans?.[key]?.MaxInternalSpan;
                                                }
                                                if (column.id.includes("MaxEndSpan")) {
                                                    inherit_value = spans?.MaxEndSpan;
                                                    if (spans?.[key]?.MaxEndSpan !== undefined)
                                                        inherit_value = spans?.[key]?.MaxEndSpan;
                                                }
                                                if (column.id.includes("MaxOverhang")) {
                                                    inherit_value = spans?.MaxOverhang;
                                                    if (spans?.[key]?.MaxOverhang !== undefined)
                                                        inherit_value = spans?.[key]?.MaxOverhang;
                                                }
                                                let value = spans?.[key]?.[column.id];
                                                if (value === undefined && column.id !== "Key") inherit = true;

                                                let display_value = "";
                                                if (column.id === "Key") display_value = key;
                                                else if (inherit) display_value = inherit_value;
                                                else display_value = value;

                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        className={classes.rowCell}
                                                        style={{
                                                            background: inherit ? "blanchedalmond" : "transparent",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                            }}
                                                        >
                                                            {inherit && (
                                                                <div
                                                                    style={{
                                                                        color: "#f59758",
                                                                        marginTop: "-4px",
                                                                        fontSize: "8px",
                                                                        // position: "absolute",
                                                                        float: "left",
                                                                        whiteSpace: "nowrap",
                                                                        height: "10px",
                                                                    }}
                                                                >
                                                                    → inherited
                                                                </div>
                                                            )}
                                                            {edit === key + "," + column.id ? (
                                                                <div
                                                                    style={{
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    <input
                                                                        autofocus
                                                                        className={classes.editor}
                                                                        type="text"
                                                                        value={value}
                                                                        onChange={(e) =>
                                                                            setSpanValue(key, column.id, e.target.value)
                                                                        }
                                                                        onKeyPress={(e) => {
                                                                            if (
                                                                                e.key === "Escape" ||
                                                                                e.key === "Enter"
                                                                            ) {
                                                                                setEdit(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                    <IconButton
                                                                        aria-label="delete"
                                                                        size="small"
                                                                        onClick={() => setEdit(null)}
                                                                        style={{
                                                                            height: "16px",
                                                                            width: "16px",
                                                                        }}
                                                                    >
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    style={{ flex: 1, cursor: "pointer" }}
                                                                    onClick={() => setEdit(key + "," + column.id)}
                                                                >
                                                                    {column.format
                                                                        ? column.format(display_value, row)
                                                                        : display_value}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </BSL_Common.SectionColumn>
                <BSL_Common.SectionColumn
                    style={{
                        width: "25%",
                        minWidth: "300px",
                    }}
                >
                    <textarea
                        id="w3review"
                        name="w3review"
                        style={{
                            backgroundColor: "beige",
                            fontFamily: "monospace",
                            padding: "10px",
                            borderRadius: "9px",
                            color: "#444444",
                            maxHeight: "400px",
                            overflowY: "auto",
                            fontSize: "12px",
                        }}
                        rows="50"
                        cols="40"
                        onChange={(e) => {
                            setDisplayData(e.target.value);
                            if (checkValidJSON(e.target.value)) {
                                setSpans(JSON.parse(e.target.value));
                            }
                        }}
                        onBlur={(e) => {
                            if (!checkValidJSON(e.target.value)) {
                                alert("JSON is not valid. Your changes may get saved...");
                                e.preventDefault();
                                return false;
                            } else {
                                setSpans(JSON.parse(e.target.value));
                                setDisplayData(JSON.stringify(JSON.parse(e.target.value), null, 4));
                            }
                        }}
                        value={displayData}
                    />
                    {/* {displayData} */}
                    {/* </textarea> */}
                    <div
                        style={{
                            color: displayDataValidJSON ? "green" : "red",
                            fontSize: "12px",
                            padding: "10px",
                            textAlign: "center",
                        }}
                    >
                        {displayDataValidJSON ? "VALID JSON" : "NOT VALID JSON"}
                    </div>
                </BSL_Common.SectionColumn>
                {/* <div
                    style={{
                        backgroundColor: "beige",
                        fontFamily: "monospace",
                        padding: "10px",
                        borderRadius: "9px",
                        color: "#444444",
                        maxHeight: "400px",
                        overflowY: "auto",
                        fontSize: "12px",
                        width: "25%",
                        minWidth: "300px",
                    }}
                >
                    {displayData}
                </div> */}
            </BSL_Common.SectionRow>
        </BSL_Dialog>
    );
}
